import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import * as React from "react";
import { TextFilterBarItem } from "./TextFilterBarItem";
import * as Resources from '../../Resources.Input';
var KeywordFilterBarItem = /** @class */ (function (_super) {
    tslib_1.__extends(KeywordFilterBarItem, _super);
    function KeywordFilterBarItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeywordFilterBarItem.prototype.getExtraTextFieldProps = function () {
        var placeholder = this.props.placeholder || Resources.KeywordFilterBarItemPlaceholderText;
        return {
            prefixIconProps: { className: "keyword-filter-icon", iconName: "Filter" },
            placeholder: placeholder,
            ariaLabel: placeholder,
            role: "search"
        };
    };
    return KeywordFilterBarItem;
}(TextFilterBarItem));
export { KeywordFilterBarItem };
export var InlineKeywordFilterBarItem = function (props) {
    return (React.createElement("div", { className: "flex-noshrink flex-row" },
        React.createElement(KeywordFilterBarItem, tslib_1.__assign({}, props, { style: 1 /* inline */, width: "bolt-textfield-inline-tabbar-width" /* tabBar */ }))));
};
